import { Pipe, PipeTransform } from '@angular/core';
import {AlertNoticeLevel, AlertNoticeLevels, EntityAlertType, EntityAlertTypes} from '../models/IAlertInfo.interface';

@Pipe({
  name: 'alertNoticeLevelString'
})
export class AlertNoticeLevelStringPipe implements PipeTransform {

  transform(value: AlertNoticeLevel) {
    return AlertNoticeLevels?.find(c => c.value === value)?.label;
  }

}
